import {
  FETCH_DASHBOARD_GLOBAL_SEARCH,
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_SYNC_USERS_BY_CRM,
} from "./types";

export const fetchDashboards = (payload: any) => {
  return {
    type: FETCH_DASHBOARD_DATA,
    payload,
  };
};

export const fetchDashboardGlobalSearch = (payload: any) => {
  return {
    type: FETCH_DASHBOARD_GLOBAL_SEARCH,
    payload,
  };
};

export const fetchDashboardSyncUsersByCRM = () => {
  return {
    type: FETCH_DASHBOARD_SYNC_USERS_BY_CRM,
  };
};
